import { webPaths } from "@zplanem/web-paths"

/**
 * Property sub-navigation config (ZPL-97). Future tabs (documents,
 * budget, tasks, shopping list) are added here + a label in
 * `t.properties.tabs` — both navs (desktop top-bar center, mobile
 * bottom bar) render from this array.
 */
export const PROPERTY_TABS = [
	{ key: "overview", path: "" },
	{ key: "projects", path: "projects" },
	{ key: "tickets", path: "tickets" },
	{ key: "documents", path: "documents" },
	{ key: "budget", path: "budget" },
	{ key: "journal", path: "journal" },
] as const

type PropertyTab = (typeof PROPERTY_TABS)[number]
export type PropertyTabKey = PropertyTab["key"]

export function propertyTabPath(propertyId: string, tab: PropertyTab): string {
	return tab.path
		? `${webPaths.property(propertyId)}/${tab.path}`
		: webPaths.property(propertyId)
}

/**
 * True on routes where the property sub-nav is shown (detail/overview +
 * projects list/detail). Excludes /properties/new and the edit/transfer
 * sub-pages. Used by MobileBottomNav to yield the bottom bar to
 * PropertyBottomNav on these routes.
 */
export function isPropertyTabRoute(pathname: string): boolean {
	if (pathname === "/properties/new") return false
	if (/\/(edit|transfer)$/.test(pathname)) return false
	return /^\/properties\/[^/]+(\/(projects(\/[^/]+(\/[^/]+)?)?|tickets(\/[^/]+)?|journal|documents|budget))?$/.test(
		pathname,
	)
}
